import { Fade, Skeleton } from "@mui/material";

const ProcessingPlaceholder = () => {
  const x = [1, 2, 3, 4, 5, 6];
  return (
    <div className="flex flex-col space-y-5 md:max-w-[430px] lg:max-w-[754px]">
      {x.map((x) => (
        <div
          key={x}
          className="max-w-[754px] max-h-[254px] bg-white mb-4 rounded-md py-3 px-4 
      "
        >
          <div className="flex flex-col space-y-2 ">
            <div className="flex flex-col space-y-4">
              <div className="flex flex-col">
                <div className="flex justify-between">
                  <Skeleton variant="text" width={227} height={34} />
                  <Skeleton variant="text" width={87} height={34} />
                </div>
                <Skeleton variant="text" width={257} height={14} />
                <Skeleton variant="text" width={157} height={14} />
              </div>
              <div className="flex flex-col">
                <div className="line"></div>
                <Skeleton variant="text" width={227} height={34} />
                <Skeleton variant="text" width={157} height={14} />
              </div>
              <div className="flex flex-col">
                <Skeleton variant="text" width={97} height={14} />
                <Skeleton variant="text" width={47} height={14} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProcessingPlaceholder;
